import { Reveal, SectionHead } from "./Reveal";

const AUDIENCE = [
  { num: "01", t: "Aspiring Film Directors", d: "You have taste and obsession but no set, no crew and no reel. Get all three." },
  { num: "02", t: "Content Creators", d: "You can post daily but your work looks like everyone else's. 10x the craft, keep the pace." },
  { num: "03", t: "Brand Designers", d: "You own static. Add motion, camera and AI to become the full-stack creative brands fight for." },
  { num: "04", t: "AI Artists", d: "Your generations are strong but nobody pays for prompts. Learn to direct them into commercial film." },
];

export const WhoFor = () => (
  <section data-testid="who-is-this-for-section" className="bg-obsidian py-28 sm:py-40">
    <div className="max-w-[1600px] mx-auto px-5 sm:px-10">
      <SectionHead num="14" eyebrow="The Fit" title="Who is this for?" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-line border border-line">
        {AUDIENCE.map((a, i) => (
          <Reveal key={a.num} delay={(i % 2) * 0.1} className="group bg-obsidian p-8 sm:p-12 hover:bg-ink transition-colors duration-300">
            <div className="flex items-baseline gap-5">
              <span className="font-display font-extrabold text-5xl sm:text-6xl text-stroke group-hover:text-acid group-hover:[-webkit-text-stroke:0] transition-all duration-300">{a.num}</span>
              <h3 className="font-head text-xl sm:text-2xl font-bold uppercase tracking-tight text-cream">{a.t}</h3>
            </div>
            <p className="mt-6 text-sm sm:text-base text-smoke leading-relaxed max-w-md">{a.d}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
